/* unplugin-vue-components disabled */import script from "./race-honors.vue?vue&type=script&lang=jsx"
export * from "./race-honors.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__